// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"5fc1e986","511":"776496bb","673":"c6301e91","767":"35900cba"}[chunkId] + ".chunk.js";
};